<template>
  <b-container fluid>
    <b-card title="Filter Dashboard">
      <b-row>
        <b-col md="12">
          <date-range-card :date="date" @filter-date="LoadDashboard" @export="ExportDashboard" />
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col md="12">
        <b-card title="Additional Information">
          <div class="text-center text-danger my-2" v-if="loadingDashboard">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
          <nota-dinas v-if="!loadingDashboard && countDocument && Object.keys(countDocument).length > 0"
            :countDocument="countDocument"/>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card title="Total Document by Portfolio">
          <div class="text-center text-danger my-2" v-if="loadingDashboard">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
          <total-document-by-category v-if="!loadingDashboard && countDocumentByCategory && Object.keys(countDocumentByCategory).length > 0"
            :countDocumentByCategory="countDocumentByCategory"/>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card title="Total Document by Type">
          <div class="text-center text-danger my-2" v-if="loadingDashboard">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
          <total-document-by-type v-if="!loadingDashboard && countDocumentByType && Object.keys(countDocumentByType).length > 0"
            :countDocumentByType="countDocumentByType"/>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card>
          <div class="text-center text-danger my-2" v-if="loadingDashboard">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
          <top-favorite v-if="!loadingDashboard && topFavorite && topFavorite.length > 0"
            :topFavorite="topFavorite"/>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card>
          <div class="text-center text-danger my-2" v-if="loadingDashboard">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
          <top-download v-if="!loadingDashboard && topDownload && topDownload.length > 0"
            :topDownload="topDownload"/>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card>
          <div class="text-center text-danger my-2" v-if="loadingDashboard">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
          <top-user v-if="!loadingDashboard && topUser && topUser.length > 0"
            :topUser="topUser"/>
        </b-card>
      </b-col>
    </b-row>
    <b-card title="Nota Dinas">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
            <b-button variant="primary" :to="{ name: 'admin-nota-dinas-add' }">
              Create Nota Dinas
            </b-button>
          </b-col>
  
          <!-- Search -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <label class="mr-1">
              Search
            </label>
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                class="d-inline-block mr-1"
                placeholder="Search..."
                v-model="searchWord"
              />
            </div>
          </b-col>
        </b-row>
      </div>
      <b-modal size="lg" title="Non-Disclosure Agreement" v-model="show" hide-footer>
        <h5> Dengan ini saya menyetujui bahwa:</h5>
        <ol>
          <li>
            <h6>Seluruh Tarif dan Dokumen Internal yang terdapat di Product Catalog bersifat
            <b>rahasia</b>
            <i>(confidential)</i>,
            terbatas hanya untuk karyawan Telkom.</h6>
          </li>
          <li>
            <h6>Berkewajiban menjaga kerahasiaan informasi Product Catalog.</h6>
          </li>
          <li>
            <h6>
              Tidak menyalahgunakan informasi yang diperoleh sehingga menyebabkan
              gangguan, hingga kerugian bagi perusahaan.
            </h6>
          </li>
          <li>
            <h6>
              Bertanggung jawab apabila terjadi penggunaan yang tidak benar terhadap
              informasi tersebut.
            </h6>
          </li>
        </ol>
        <b-form-checkbox class="mt-2" v-model="isChecked">Saya menyetujui dan memahami <b>Non-Disclosure Agreement</b> di atas</b-form-checkbox>
        <div class="d-flex justify-content-center align-items-center">
          <b-button size="sm" variant="light" class="mt-3 mr-2 w-25">Cancel</b-button>
          <b-button size="sm" @click="authorizedDownload" variant="primary" class="mt-3 w-25">Ok</b-button>
        </div>
      </b-modal>
      <div v-if="selectedRows.length > 0" class="mb-1">
        <b-alert show variant="light" style="color:black" class="d-flex">
          <span @click="deleteSelected"><feather-icon class="" size="18" icon="XIcon" /></span>
          <span class="ml-2">{{ selectedRows.length }} Selected</span>
          <span v-if="!loadDownload" @click="multipleDownload" style="cursor:pointer"><feather-icon class="ml-1" size="18" icon="DownloadIcon" /></span>
          <span v-else class="ml-1"><indicatorLoad /></span>
          <span v-if="!loadDelete" @click="multipleDelete" style="cursor:pointer">
            <feather-icon class="ml-1" size="18" icon="Trash2Icon" />
          </span>
          <span v-else class="ml-1"><indicatorLoad /></span>
        </b-alert>
      </div>
      <!-- Larger screen than mobile -->
      <div class="d-none d-md-flex">
        <!-- Table -->
        <b-table responsive :items="notadinasdata" :fields="fields" :busy="isBusy" @sort-changed="onSortChanged" @row-clicked="selectRow" :tbody-tr-class="rowClass">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
              <strong class="text-secondary">Loading...</strong>
            </div>
          </template>
          <template #cell(action)="notadinasdata">
            <div class="d-flex justify-content-start">
              <b-button @click="singleDownload(notadinasdata.item.path)" v-ripple.400="'rgba(255, 255, 255, 0.15)'" class="btn-icon mr-1" size="md" variant="primary">
                <span><feather-icon size="14" icon="DownloadIcon" /></span>
              </b-button>
              <b-dropdown id="dropdown-dropleft" dropleft v-ripple.400="'rgba(255, 255, 255, 0.15)'" 
                variant="secondary" class="btn-icon mr-1" no-caret>
                <template #button-content>
                  <feather-icon icon="Edit3Icon" />
                </template>
                <b-dropdown-item @click="updateDocWindow(notadinasdata.item.id, notadinasdata.item.name, 'rename')">Rename</b-dropdown-item>
                <b-dropdown-item @click="updateDocWindow(notadinasdata.item.id, notadinasdata.item.name, 'fullUpdate')">Edit Document</b-dropdown-item>
              </b-dropdown>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="btn-icon"
                @click="confirmDelete(notadinasdata.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button> 
            </div>
          </template>
          <template #cell(name)="notadinasdata">
            <div :inner-html.prop="notadinasdata.item.name"></div>
          </template>
          <template #cell(documentDate)="notadinasdata">
            <div :inner-html.prop="notadinasdata.item.date"></div>
          </template>
          <!-- <template #cell(createdDate)="notadinasdata">
            <div :inner-html.prop="notadinasdata.item.created_at"></div>
          </template> -->
          <template #cell(type)="notadinasdata">
            <div :inner-html.prop="notadinasdata.item.type_nd"></div>
          </template>
        </b-table>
      </div>
      <!-- Mobile screen -->
      <div class="d-flex d-md-none flex-column">
        <!-- Loading -->
        <div v-if="isBusy" class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
          <strong class="text-secondary">Loading...</strong>
        </div>
        <!-- Data -->
        <b-row
          v-if="!isBusy"
          v-for="(item, index) in notadinasdata"
          :key="item.id"
          class="mb-3 list-item"
          :class="rowClass(item)"
          @click="selectRow(item)"
        >
          <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
            <strong class="flex-grow-1 truncate">{{ item.name }}</strong>
            <div @click.stop>
              <b-button @click="singleDownload(item.path)" v-ripple.400="'rgba(255, 255, 255, 0.15)'" class="btn-icon mr-1" size="md" variant="primary">
                <span><feather-icon size="14" icon="DownloadIcon" /></span>
              </b-button>
              <b-dropdown id="dropdown-dropleft" dropleft v-ripple.400="'rgba(255, 255, 255, 0.15)'" 
                variant="secondary" class="btn-icon mr-1" no-caret>
                <template #button-content>
                  <feather-icon icon="Edit3Icon" />
                </template>
                <b-dropdown-item @click="updateDocWindow(item.id, item.name, 'rename')">Rename</b-dropdown-item>
                <b-dropdown-item @click="updateDocWindow(item.id, item.name, 'fullUpdate')">Edit Document</b-dropdown-item>
              </b-dropdown>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="btn-icon"
                @click="confirmDelete(item.id)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button> 
            </div>
          </b-col>
          <b-col cols="12" class="d-flex flex-wrap">
            <div style="font-size: 0.75rem;">
              <p><strong>PORTFOLIO:</strong> {{ item.category }}</p>
              <p><strong>TYPE:</strong> {{ item.type_nd }}</p>
              <p><strong>DOCUMENT DATE:</strong> {{ item.date }}</p>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">
              Showing {{ pagination.from }} to {{ pagination.to }} of
              {{ pagination.total }} entries
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="pagination.total"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="changePage"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
        <b-modal
          id="modal-update-notadinas"
          cancel-variant="outline-secondary"
          ok-title="Ok"
          cancel-title="Close"
          centered
          title="Rename File"
          ref="modalUpdateFile"
          no-close-on-backdrop
          
          no-close-on-esc
          :ok-disabled="!canUpdateFile"
          @ok="
            $event.preventDefault()
            updateFile()
          "
        >
          <b-form>
            <b-form-group label="" label-for="">
              <b-form-input id="name" v-model="updateForm.name" required />
            </b-form-group>
          </b-form>
          <template #modal-ok>
            <div v-if="!loadingUpdateFile">
              Save
            </div>
            <b-spinner v-else variant="white" label="Spinning" small />
          </template>
        </b-modal>
      </div>
    </b-card>
  </b-container>
</template>

<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BSpinner,
  BFormCheckbox,
  BModal,
  BImg,
  BFormFile,
  BFormGroup,
  BForm,
  BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { generateToken } from '@/auth/helperAuth'
import indicatorLoad from './indicatorLoad.vue'
import DateRangeCard from './dashboard/dateRangeCard.vue'
import NotaDinas from './dashboard/notaDinas.vue'
import TotalDocumentByCategory from './dashboard/totalDocumentByCategory.vue'
import TotalDocumentByType from './dashboard/totalDocumentByType.vue'
import TopFavorite from './dashboard/topFavorite.vue'
import TopDownload from './dashboard/topDownload.vue'
import TopUser from './dashboard/topUser.vue'
import * as Services from './dashboard/services'
import * as XLSX from 'xlsx';

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BFormGroup,
    BForm,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    BFormCheckbox,
    BModal,
    BImg,
    BFormFile,
    vSelect,
    indicatorLoad,
    BAlert,
    DateRangeCard,
    NotaDinas,
    TotalDocumentByCategory,
    TotalDocumentByType,
    TopFavorite,
    TopDownload,
    TopUser,
  },
  data() {
    const { dateFrom: from, dateTo: to } = Services
    return {
      token: '',
      date: {
        from,
        to,
      },
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      fields: [
        { key: 'name', sortable: true },
        { key: 'category', label: 'Portfolio', sortable: true},
        { key: 'type', sortable: true},
        { key: 'documentDate', sortable: true},
        // { key: 'createdDate', sortable: true},
        'action',
      ],
      notadinasdata: [],
      searchWord: '',
      typeUpdate: '',
      updateForm: {
        id: '',
        name: '',
      },
      loadingUpdateFile: false,
      sortField : '',
      orderBy: '',
      selectedRows: [],
      show:false,
      statusDownload: '',
      downloadPath: '',
      isChecked:false,
      loadDelete: false,
      loadDownload: false,
      countDocumentByCategory: '',
      countDocumentByType: '',
      countDocument: '',
      topFavorite: '',
      topDownload: '',
      topUser: '',
      loadingDashboard: true,
    }
  },

  directives: {
    Ripple,
  },

  watch: {
    perPage() {
      this.fetchNotaDinas()
    },
    currentPage() {
      this.fetchNotaDinas()
    },
    searchWord() {
      this.fetchNotaDinas()
    },
    orderBy(){
      this.fetchNotaDinas()
    },
    sortField(){
      this.fetchNotaDinas()
    }
  },

  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    }
    this.token = generateToken(payload)
    this.LoadDashboard()
  },

  filters: {
    truncate: function(value, length, start = 0) {
      if (!value) return ''
      value = value.toString()
      if (value.length > length) {
        if (start > 0) {
          return value.substring(start, length + start) + '...'
        } else {
          return value.substring(start, length) + '...'
        }
      } else {
        return value
      }
    },
  },

  mounted() {
    this.fetchNotaDinas()
  },

  computed: {
    canUpdateFile() {
      return !this.loadingUpdateFile && this.fileUpdate !== null
    }
  },

  methods: {
    updateDocWindow(id, name, type) {
      if(type == 'rename'){
        this.updateForm.id = id
        this.updateForm.name = name
        this.$refs.modalUpdateFile.show()
        this.typeUpdate = type 
      }else{
        this.typeUpdate = type
        localStorage.setItem('currentPage', this.currentPage)
        window.location.href = `/admin/notadinas/update/${id}?page=${this.currentPage}`
      }
    },
    fetchNotaDinas() {
      const savedPage = localStorage.getItem('currentPage')
      if (savedPage) {
        this.currentPage = parseInt(savedPage, 10)
        localStorage.removeItem('currentPage')
      }
      this.isBusy = true
      this.$http
        .get(`${process.env.VUE_APP_API_HELPER_URL}/attachment/list`, {
          params: {
            page: savedPage ? savedPage : this.currentPage,
            perPage: this.perPage,
            s: this.searchWord.toString().trim(),
            sort: (this.sortField !== '') ? this.sortField : 'date',
            order: (this.orderBy !== '') ? this.orderBy : 'DESC',
            type: 'NotaDinas'
          },
          withCredentials: false,
          headers: {'Client-Device': 'browser', 'Authorization': `${this.token}`}
        })
        .then(response => {
          this.pagination.from = response.data.from
          this.pagination.to = response.data.to
          this.pagination.total = response.data.total
          this.currentPage = savedPage ? savedPage : response.data.current_page
          this.notadinasdata = response.data.data.map(item => ({
          ...item,
          }))
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    updateFile() {
      const fd = new FormData()
      if(this.typeUpdate == 'rename'){
        fd.append('id', this.updateForm.id)
        fd.append('name', this.updateForm.name)
      }
      this.$set(this, 'loadingUpdateFile', true)
      this.$http.put(`${process.env.VUE_APP_API_HELPER_URL}/attachment/notaDinas/update`, fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: false,
        headers : {'Client-Device': 'browser', 'Authorization': `${this.token}`}
      })
        .then(() => {
          this.$notif(
            'Success',
            'File updated.',
            'success'
          )
        })
        .catch(() => {
          this.$notif(
            'Error',
            'Error while uploading File',
            'danger'
          )
        })
        .finally(() => {
          this.$set(this, 'loadingUpdateFile', false)
          this.$refs.modalUpdateFile.hide()
          this.fetchNotaDinas()
          // window.location.reload()
        })
    },
    async delete(id) {
      this.isBusy = true
      return await this.$http
        .delete(`${process.env.VUE_APP_API_HELPER_URL}/attachment?id=${id}`, {withCredentials: false, headers: {'Client-Device': 'browser', 'Authorization': `${this.token}`}})
        .then(res => {
          this.$notif(
            'Success',
            'News has been successfully deleted.',
            'success'
          )
        })
        .catch(({ data }) => {
          this.$notif('Something Error', data.message, 'danger')
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.delete(id).then(() => {
              this.fetchNotaDinas()
            })
          }
        })
    },
    changePage(page) {
      this.currentPage = page
    },
    onSortChanged(ctx){
      if(ctx.sortBy == 'category'){
        this.sortField = 'pc.name'
      }else if(ctx.sortBy == 'type') {
        this.sortField = 'nd.type'
      }else if(ctx.sortBy == 'documentDate'){
        this.sortField = 'date'
      }else{
        this.sortField = ctx.sortBy
      }
      this.orderBy = ( (ctx.sortDesc == false ) ? 'ASC' : 'DESC')
    },
    selectRow(item, index) {
      const foundIndex = this.selectedRows.findIndex(row => row.id === item.id)
      if (foundIndex === -1) {
        this.selectedRows.push(item)
      } else {
        this.selectedRows.splice(foundIndex, 1)
      }
    },
    rowClass(item) {
      return this.selectedRows.some(row => row.id === item.id) ? 'table-row-selected' : 'pointer-row';
    },
    deleteSelected() {
      this.selectedRows = []
    },
    multipleDelete() {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.loadDelete = true
            const id = []
            this.selectedRows.forEach(item => { id.push(item.id.toString()) })
            const mapRequest = { ids: id }
            this.$http.delete(`${process.env.VUE_APP_API_HELPER_URL}/attachment/multiple`, {
              data: mapRequest,
              headers: {
                'Authorization': `${this.token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/zip'
              }
            })
            .then(res => {
                if(res.status == 200){
                  this.fetchNotaDinas()
                  this.selectedRows = []
                }
              })
              .catch(err => {
                console.log(err)
              })
              .finally(() => (this.loadDelete = false)
            )
          }
        })
    },
    singleDownload(path) {
      this.downloadPath = path
      this.statusDownload = 'single'
      this.show = true
    },
    multipleDownload(){
      this.show = true
      this.statusDownload = 'multiple'
    },
    async authorizedDownload() {
      if (this.isChecked && this.statusDownload === 'single') {
        try {
          const response = await fetch(`${process.env.VUE_APP_API_HELPER_URL}/attachment?path=${encodeURIComponent(this.downloadPath)}`, {
            method: 'GET',
            headers: {
              'Authorization': `${this.token}`,
              'Accept': 'application/json',
            },
          })
          if (!response.ok) {
            throw new Error(`Error downloading file: ${response.statusText}`)
          }
          const blob = await response.blob()
          const downloadUrl = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = downloadUrl
          link.download = this.getFileNameFromPath(this.downloadPath)
          document.body.appendChild(link)
          link.click()

          URL.revokeObjectURL(downloadUrl)
          document.body.removeChild(link)

          this.isChecked = false
          this.show = false
        } catch (error) {
          console.error(error.message);
        }
      }else if(this.isChecked && this.statusDownload == 'multiple'){
        const path = []
        this.show = false
        this.loadDownload = true
        this.selectedRows.forEach(item => { path.push(item.path) })
        const mapRequest = { paths: path }
        this.$http.post(`${process.env.VUE_APP_API_HELPER_URL}/attachment/multiple`, mapRequest, {
          withCredentials: true,
          headers: { 
            'Authorization': `${this.token}`, 
            'Content-Type': 'application/json', 
            'Accept': 'application/zip' 
          },
          responseType: 'blob'
        })
        .then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Nota Dinas.zip')
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
            window.URL.revokeObjectURL(url)
            this.selectedRows = []
          })
          .catch(err => {
            if (typeof err.data.errors !== 'undefined') {
              this.$notif('Error', err.data.errors.file[0], 'error')
            }else{
              this.errString = err.data.replace(",","<br>")
              this.$notif('Error', `Something wrong`, 'error')
            }
          })
          .finally(() => (
            this.loadDownload = false
          )
        )
        }else{
        this.$notifOnClick(
          'Forbidden!', 
          "Downloading this file is strictly prohibited. Unauthorized access or distribution of this content is against our policy and may result in serious consequences, including legal action. Please respect these restrictions and do not attempt to download or share this file without proper authorization", 
          'danger', 
          'AlertTriangleIcon',
          'danger',
          'OK',
          () => {})
        this.isChecked = false
        this.show = false
      }
    },
    getFileNameFromPath(path) {
      return path.split('/').pop()
    },
    ExportDashboard(){
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/dashboard/attachment/summary?startCreatedDate=${this.date.from.value}&endCreatedDate=${this.date.to.value}`, {
        withCredentials: true,
        headers: {
          'Client-Device': 'browser',
          'Authorization': `${this.token}`,
          'Accept': 'application/json'
        },
      })
        .then(({ data }) => {
          const workbook = XLSX.utils.book_new();
          
          // Additional Information
          const valueAdditionalInformation = [[data.summary.NotaDinas.total, data.summary.NotaDinas.download]]
          const worksheetDataAdditionalInfo = [['Total Document', 'Total Download Document'], ...valueAdditionalInformation];
          const worksheetAdditionalInfo = XLSX.utils.aoa_to_sheet(worksheetDataAdditionalInfo);
          XLSX.utils.book_append_sheet(workbook, worksheetAdditionalInfo, 'Additional Information');

          // Total Document by Category
          const headerDocumentCategory = []
          const valueDocumentCategory = [[]]
          for(const i in data.summary.NotaDinas.category){
            headerDocumentCategory.push(i)
            valueDocumentCategory[0].push(data.summary.NotaDinas.category[i])
          }
          const worksheetDataDocCategory = [headerDocumentCategory, ...valueDocumentCategory];
          const worksheetDocCategory = XLSX.utils.aoa_to_sheet(worksheetDataDocCategory);
          XLSX.utils.book_append_sheet(workbook, worksheetDocCategory, 'Total Document by Category');
          
          // Total Document by Type
          const headerDocumentType = []
          const valueDocumentType = [[]]
          for(const i in data.summary.NotaDinas.type){
            headerDocumentType.push(i)
            valueDocumentType[0].push(data.summary.NotaDinas.type[i])
          }
          const worksheetDataDocType = [headerDocumentType, ...valueDocumentType];
          const worksheetDocType = XLSX.utils.aoa_to_sheet(worksheetDataDocType);
          XLSX.utils.book_append_sheet(workbook, worksheetDocType, 'Total Document by Type');

          // Top
          const top5Favorite = []
          const top5Download = []
          const top5MostActiveUsersDownload = []
          for (let index = 0; index < 5; index++) {
            top5Favorite.push([
              (index+1),
              data.action.favorite.NotaDinas[index] ?  data.action.favorite.NotaDinas[index].name : '-',
              data.action.favorite.NotaDinas[index] ?  data.action.favorite.NotaDinas[index].total : '-',
            ])
            top5Download.push([
              (index+1),
              data.action.download.NotaDinas[index] ? data.action.download.NotaDinas[index].name : '-',
              data.action.download.NotaDinas[index] ? data.action.download.NotaDinas[index].total : '-'
            ])
            top5MostActiveUsersDownload.push([
              (index+1),
              data.userActivity.download.NotaDinas[index] ? data.userActivity.download.NotaDinas[index].name_user : '-',
              data.userActivity.download.NotaDinas[index] ? data.userActivity.download.NotaDinas[index].total : '-'
            ])
          }
          const worksheetData = [['No', 'Top 5 Favorite', 'Views'], ...top5Favorite];
          const worksheetFavorite = XLSX.utils.aoa_to_sheet(worksheetData);
          XLSX.utils.book_append_sheet(workbook, worksheetFavorite, 'Top 5 Download');

          const worksheetData2 = [['No', 'Top 5 Download', 'Views'], ...top5Download];
          const worksheetDownload = XLSX.utils.aoa_to_sheet(worksheetData2);
          XLSX.utils.book_append_sheet(workbook, worksheetDownload, 'Top 5 Total');

          const worksheetData3 = [['No', 'Top 5 Most Active Users Download', 'Total'], ...top5MostActiveUsersDownload];
          const worksheetUser = XLSX.utils.aoa_to_sheet(worksheetData3);
          XLSX.utils.book_append_sheet(workbook, worksheetUser, 'Top 5 Active Users Download');

          XLSX.writeFile(workbook, 'Export Dashboard Nota Dinas.xlsx');
        })
        .catch(err => {
          console.error('Fetch failed:', err)
          this.loadingDashboard = false
        })
        .finally(() => {
          this.loadingDashboard = false
        });
    },
    LoadDashboard(){
      this.loadingDashboard = true
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/dashboard/attachment/summary?startCreatedDate=${this.date.from.value}&endCreatedDate=${this.date.to.value}`, {
        withCredentials: true,
        headers: {
          'Client-Device': 'browser',
          'Authorization': `${this.token}`,
          'Accept': 'application/json'
        },
      })
        .then(({ data }) => {
          this.countDocumentByCategory = data.summary.NotaDinas.category
          this.countDocumentByType = data.summary.NotaDinas.type
          this.countDocument = {
            totalDocument: data.summary.NotaDinas.total,
            totalDownload: data.summary.NotaDinas.download,
            totalUpload: 0,
          }
          const topFavorite = []
          const topDownload = []
          const topUser = []
          for (let index = 0; index < 5; index++) {
            topFavorite.push({
              name: data.action.favorite.NotaDinas[index] ?  data.action.favorite.NotaDinas[index].name : '-',
              total: data.action.favorite.NotaDinas[index] ?  data.action.favorite.NotaDinas[index].total : '-',
            })
            topDownload.push({
              name: data.action.download.NotaDinas[index] ? data.action.download.NotaDinas[index].name : '-',
              total: data.action.download.NotaDinas[index] ? data.action.download.NotaDinas[index].total : '-',
            })
            topUser.push({
              name: data.userActivity.download.NotaDinas[index] ? data.userActivity.download.NotaDinas[index].name_user : '-',
              total: data.userActivity.download.NotaDinas[index] ? data.userActivity.download.NotaDinas[index].total : '-',
            })
          }
          this.topFavorite = topFavorite
          this.topDownload = topDownload
          this.topUser = topUser
        })
        .catch(err => {
          console.error('Fetch failed:', err)
          this.loadingDashboard = false
        })
        .finally(() => {
          this.loadingDashboard = false
        });
    }
  },
}
</script>
<style>
.modal-header {
  background-color: red !important;
}
.modal-title {
  color:white !important;
  font-weight: 600
}
.table-row-selected {
  background-color: #f7d5d5 !important;
  cursor: pointer;
}
.pointer-row{
  cursor: pointer;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
